
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const vlc: IProductData = {
  id: "hazelriggindustries-vlc",
  name: "Hazelrigg Industries VLC",
  description: "Vacuum Tube Mic Pre, DI, & EQ",
  specialOrder: true,
  images: ["/img/hazelriggindustries_vlc_front.png", "/img/hazelriggindustries_vlc_back.png"],
  details: [{
    label: "Description",
    markdown: `
The debut offering in the Hazelrigg Industries Solutions Series, the VLC is a powerful and elegant All-Tube Preamp/EQ combination designed to address the sonic challenges faced by today’s audio professionals.  

The VLC is simply a solution: an elegant, high-performance Preamp/EQ/DI combo that delivers world class sonics while still being able to fit into the overhead bin.  
The foundation of the VLC is the legendary Preamp and Power Supply design utilized in the VT series of Tube Microphone Preamplifiers from D.W. Fearn. Designed for sonic transparency and delivering incredible headroom, the VLC will produce stunning results with dynamic, condenser and ribbon microphones and will change the way that you approach your mic locker during a session.  

A rotary switch on the front panel will also select between Microphone, Instrument Input (DI) or the Balanced Line Level Input located on the back panel. The all tube DI path is ideal for acoustic instruments with pickups, electric bass, modular synths or any instrument that would enjoy a bit of D. W. Fearn magic, while the Line Level Input allows the VLC to be wired as an insert on your mixer or DAW for fast and easy “re-preamping” of tracks during production or mix down. This feature is the secret weapon of many VLC users and allows them to breathe new life into tracks received from remote clients or simply add a bit of extra mojo to a mix as needed.  
Moving beyond the input and gain sections, the VLC delivers powerful tone contouring in the form of a passive LC EQ.  The bottom is handled by variable Low Cut and Low Boost controls while the top end is managed similarly with High Boost and High Cut dials. Each of these four controls features a two way High/Low Frequency Select switch for even more precise tone shaping. Beautifully musical - even at extreme settings - these controls encourage you to use your ears to dial in your tone while an EQ In/Out toggle is nearby to make it easy to check your work.  
`
  }, {
    label: "Specification",
    markdown: `
- Transformer Coupled Input and Output
- Front Panel Microphone/Instrument Input
- Dedicated Balanced Line Input on Rear Panel (Selectable from the Front Panel)
- Redundant Microphone Input on Rear Panel
- 4-Way Lo Cut / MIC / LINE / INST Selector
- Aircraft Inspired Locking +48V Safety Switch
- -20dB Pad Switch
- Polarity Reversal Switch
- EQ Bypass Switch
- Passive EQ
- Custom-wound Inductor
- Low Cut , Low Boost, High Cut & High Boost Controls
- 2-way Frequency Selector for Each Band
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/vlc" target="_blank">https://www.hazelriggindustries.com/vlc</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.RACK, HASHTAGS.ONE_U, HASHTAGS.EQ, HASHTAGS.MICPRE],
    manufacturer: BRAND.HAZELRIGG,
  }
}